export default "__VITE_ASSET__2hwABCR2__"